import { useEffect, useRef } from "react";

const DEFAULT_REFRESH_INTERVAL = 10000;

/**
 * Keeps server-backed lists current without reloading the whole page.
 * It refreshes periodically and immediately when the user returns to the tab.
 */
const useAutoRefresh = (refresh, interval = DEFAULT_REFRESH_INTERVAL) => {
  const refreshRef = useRef(refresh);

  useEffect(() => {
    refreshRef.current = refresh;
  }, [refresh]);

  useEffect(() => {
    const refreshIfVisible = () => {
      if (document.visibilityState === "visible") {
        refreshRef.current?.();
      }
    };

    const timer = window.setInterval(refreshIfVisible, interval);
    window.addEventListener("focus", refreshIfVisible);
    document.addEventListener("visibilitychange", refreshIfVisible);

    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", refreshIfVisible);
      document.removeEventListener("visibilitychange", refreshIfVisible);
    };
  }, [interval]);
};

export default useAutoRefresh;
